<template>
  <section class="page-section business-page" data-page="2">
    <div class="page-container">
      <h2 class="page-title">
        <span class="title-highlight">业务矩阵</span>
        <span class="title-subtitle">Business Matrix</span>
      </h2>
      <div class="scope-modules-compact">
        <div 
          class="scope-module-compact" 
          v-for="(module, index) in modules" 
          :key="index"
          :class="`module-${index + 1}`"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <div class="module-header">
            <div class="module-icon">{{ getModuleIcon(index) }}</div>
            <div class="module-number">{{ String(index + 1).padStart(2, '0') }}</div>
          </div>
          <h4>{{ module.title }}</h4>
          <p>{{ module.content }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BusinessMatrix',
  data() {
    return {
      modules: [
        { title: "数字化文物保护与修复", content: "利用激光扫描、摄影测量等先进技术，实现文物的数字化保存与修复，确保文物的文化价值和历史传承。" },
        { title: "高新材料仿真孪生与修复", content: "运用3D打印技术与新型材料，实现文物的精确复制与高效修复，突破传统修复方式的局限。" },
        { title: "文博元宇宙智能展陈", content: "结合全息线上博物馆与沉浸式线下展览，打造虚实结合的文化体验，让观众感受历史文化魅力。" },
        { title: "文物智能化安全管理", content: "通过智能化平台、移动端工具和数据安防系统，实现文物的全面安全管理与保护。" },
        { title: "大数据与人工智能的创新应用", content: "结合大数据与AI技术，推动文化遗产数字化与智能监测，为文物保护与教育提供精准服务。" },
        { title: "文化学术科研与教育支持", content: "凭借顶尖科研团队和合作伙伴，推动文物保护领域的技术创新与教育发展。" },
        { title: "IP运营和宣传推广", content: "通过数字化转型商业化遗产，赋予其新的经济价值，推动文化IP的产业化。" }
      ]
    };
  },
  methods: {
    getModuleIcon(index) {
      const icons = ['🏛️', '🔬', '🌐', '🛡️', '🤖', '📚', '🎨'];
      return icons[index] || '⭐';
    }
  }
};
</script>

<style scoped>
.business-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.scope-modules-compact {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 30px;
  width: 100%;
  height: 70%;
  max-width: 1400px;
  margin: 0 auto;
  justify-items: stretch;
  align-items: stretch;
}

.scope-module-compact {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 25px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  min-height: 160px;
  display: flex;
  flex-direction: column;
}

/* 第一行：第一个业务占2格，第二个业务占1格 */
.module-1 {
  grid-column: 1 / 3;
  grid-row: 1;
}

.module-2 {
  grid-column: 3;
  grid-row: 1;
}

/* 第二行：第一个业务占1格，第二个业务占2格 */
.module-3 {
  grid-column: 1;
  grid-row: 2;
}

.module-4 {
  grid-column: 2 / 4;
  grid-row: 2;
}

/* 第三行：三个业务各占1格 */
.module-5 {
  grid-column: 1;
  grid-row: 3;
}

.module-6 {
  grid-column: 2;
  grid-row: 3;
}

.module-7 {
  grid-column: 3;
  grid-row: 3;
}

.scope-module-compact:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-shrink: 0;
}

.module-icon {
  font-size: 1.6rem;
}

.module-number {
  font-size: 0.8rem;
  opacity: 0.7;
  font-weight: 600;
}

.scope-module-compact h4 {
  font-size: 1rem;
  font-weight: 600;
  margin: 12px 0 10px 0;
  color: #ffffff;
  line-height: 1.3;
  flex-shrink: 0;
}

.scope-module-compact p {
  font-size: 0.8rem;
  line-height: 1.5;
  opacity: 0.9;
  margin: 0;
  flex-grow: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

/* 为占2格的模块调整字体大小 */
.module-1 h4,
.module-4 h4 {
  font-size: 1.1rem;
}

.module-1 p,
.module-4 p {
  font-size: 0.85rem;
  -webkit-line-clamp: 4;
}

/* 为占1格的模块限制文本行数 */
.module-2 p,
.module-3 p,
.module-5 p,
.module-6 p,
.module-7 p {
  -webkit-line-clamp: 3;
}

/* 平板布局 */
@media (max-width: 1024px) and (min-width: 769px) {
  .scope-modules-compact {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap: 25px;
    padding: 30px;
    max-width: 900px;
  }
  
  .scope-module-compact {
    padding: 20px;
    min-height: 140px;
  }
  
  /* 重新排列为2列布局 */
  .module-1 {
    grid-column: 1 / 3;
    grid-row: 1;
  }
  
  .module-2 {
    grid-column: 1;
    grid-row: 2;
  }
  
  .module-3 {
    grid-column: 2;
    grid-row: 2;
  }
  
  .module-4 {
    grid-column: 1 / 3;
    grid-row: 3;
  }
  
  .module-5 {
    grid-column: 1;
    grid-row: 4;
  }
  
  .module-6 {
    grid-column: 2;
    grid-row: 4;
  }
  
  .module-7 {
    grid-column: 1 / 3;
    grid-row: 5;
  }
  
  .module-icon {
    font-size: 1.4rem;
  }
  
  .scope-module-compact h4 {
    font-size: 0.9rem;
  }
  
  .scope-module-compact p {
    font-size: 0.75rem;
  }
}

/* 小屏幕布局 */
@media (max-width: 768px) and (min-width: 481px) {
  .scope-modules-compact {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(7, auto);
    gap: 20px;

    max-width: 500px;
  }
  
  .scope-module-compact {
    padding: 18px;
    min-height: 120px;
  }
  
  /* 所有模块占满宽度 */
  .module-1,
  .module-2,
  .module-3,
  .module-4,
  .module-5,
  .module-6,
  .module-7 {
    grid-column: 1;
    grid-row: auto;
  }
  
  .module-icon {
    font-size: 1.3rem;
  }
  
  .scope-module-compact h4 {
    font-size: 0.85rem;
  }
  
  .scope-module-compact p {
    font-size: 0.7rem;
    -webkit-line-clamp: 3;
  }
}

/* 手机布局 */
@media (max-width: 480px) {
  .scope-modules-compact {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(7, auto);
    gap: 15px;

    max-width: 100%;
  }
  
  .scope-module-compact {
    padding: 15px;
    min-height: 100px;
  }
  
  /* 所有模块占满宽度 */
  .module-1,
  .module-2,
  .module-3,
  .module-4,
  .module-5,
  .module-6,
  .module-7 {
    grid-column: 1;
    grid-row: auto;
  }
  
  .module-icon {
    font-size: 1.2rem;
  }
  
  .scope-module-compact h4 {
    font-size: 0.8rem;
  }
  
  .scope-module-compact p {
    font-size: 0.65rem;
    -webkit-line-clamp: 2;
  }
}
</style>